<div class="flex flex-col gap-[9px] mb-7">
  <ui-skeleton class="block h-3.5 w-[98px] rounded-full" />
  <ui-skeleton class="block h-3 w-[282px] rounded-full" />
</div>
<div class="border-t border-surface-highlight dark:border-surface-highlight-darkmode">
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <ui-skeleton class="h-3 w-[100px] rounded-full" />
    <ui-skeleton class="h-3 w-[130px] rounded-full" />
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <div class="flex gap-1 items-center">
      <ui-skeleton class="h-3 w-[50px] rounded-full" />
      <ui-skeleton class="h-5 w-5 rounded-full" />
    </div>
    <ui-skeleton class="h-6 w-[100px] rounded-sm" />
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <ui-skeleton class="h-3 w-[100px] rounded-full" />
    <div class="flex gap-1 items-center">
      <ui-skeleton class="h-5 w-5 rounded-full" />
      <ui-skeleton class="h-3 w-[70px] rounded-full" />
    </div>
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <div class="flex gap-1 items-center">
      <ui-skeleton class="h-3 w-[25px] rounded-full" />
      <ui-skeleton class="h-5 w-5 rounded-full" />
    </div>
    <ui-skeleton class="h-3 w-[30px] rounded-full" />
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <div class="flex gap-1 items-center">
      <ui-skeleton class="h-3 w-[150px] rounded-full" />
      <ui-skeleton class="h-5 w-5 rounded-full" />
    </div>
    <ui-skeleton class="h-3 w-[140px] rounded-full" />
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <div class="flex gap-1 items-center">
      <ui-skeleton class="h-3 w-[130px] rounded-full" />
      <ui-skeleton class="h-5 w-5 rounded-full" />
    </div>
    <ui-skeleton class="h-3 w-[180px] rounded-full" />
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <ui-skeleton class="h-3 w-[100px] rounded-full" />
    <ui-skeleton class="h-3 w-[300px] rounded-full" />
  </div>
  <div
    class="h-22 grid grid-cols-1 sm:grid-cols-2 items-center border-b border-surface-highlight dark:border-surface-highlight-darkmode"
  >
    <ui-skeleton class="h-3 w-[100px] rounded-full" />
    <ui-skeleton class="h-3 w-[30px] rounded-full" />
  </div>
</div>
